import { has, isObjectLike } from 'lodash'

export interface ExternalProviderState {
  code_verifier: string
  challenge: string
  returnUrl: string
}

export const isExternalProviderState = (obj: unknown): obj is ExternalProviderState => {
  return isObjectLike(obj) && has(obj, 'code_verifier') && has(obj, 'challenge') && has(obj, 'returnUrl')
}
